export const API_ROUTES = {
  INQUIRY: {
    GET_INQUIRY: (query) => `/inquiry?${query}`,
    GET_INQUIRY_BY_ID:(inquiryId) => `/inquiry/${inquiryId}`,
    POST_INQUIRY: '/inquiry',
    PUT_INQUIRY: '/inquiry',
    GET_INQUIRY_FOLLOWUP: (inquiryId) => `/inquiry/followup/${inquiryId}`,
    POST_INQUIRY_FOLLOWUP: '/inquiry/followup',
    // PUT_INQUIRY_FOLLOWUP:'/inquiry/followup',
    POST_INQUIRY_ARCHIVE: (inquiryId) => `/inquiry/${inquiryId}/archive`,
  },
  AUTH: {
    GET_USERS: (userRole) => `auth/user/${userRole}`,
  },
  EXAM: {
    GET_EXAM: (facultyId) => `/faculty/${facultyId}/all-exam-list`,
    GET_RESULT: (timetableId) => `/online-exam-list/${timetableId}`,
    GET_ASSESSMENT: (studentId) => `/online-exam/${studentId}`,
    CREATE_CORRECT_ANS: `/assessment`,
  },
  FACULTY: {
    GET_FACULTY_DASHBOARD: (facultyId) => `faculty-timetable/${facultyId}/timetable`,
    GET_FACULTY_DASHBOARD_PAYMENT: (facultyId) => `faculty/${facultyId}/billing-info`,
  },
  ADD_FACULTY: {
    POST_FACULTY: '/faculty',
    PUT_FACULTY: (facultyId) => `/faculty/${facultyId}`,
    GET_BANK: '/banks',
    GET_FACULTY_BILLING_INFO: (facultyId) => `faculty/${facultyId}/billing-info`,
  },
  FACULTY_PROFILE: {
    GET_FACULTY_PROFILE: (facultyId) => `/faculty/details/${facultyId}`,
    GET_FACULTY_BANK_DETAIL: (facultyId) => `/faculty/bankdetails/${facultyId}`,
    PUT_FACULTY_BANK_DETAIL: (facultyId) => `/faculty/bankdetails/${facultyId}`,
    GET_FACULTY_PROFILE_PHOTO: (facultyId) => `/faculty/${facultyId}/profile-photo`,
    PUT_FACULTY_PROFILE_PHOTO: (facultyId) => `/faculty/${facultyId}/upload-profile`,
  },
  MASTER_DATA_SET: {
    GET_STATE_LIST: '/state',
    GET_CITY_LIST: '/city',
    GET_AREA_LIST: '/area',
    GET_USER_ROLES: '/roles',
    GET_CITY_BY_STATE_ID:(stateId)=> `/states/${stateId}/cities`,
    GET_AREA_BY_CITY_ID:(cityId)=> `/cities/${cityId}/areas`

  },
  TIMETABLE: {
    GET_TIMETABLE: '/timetable',
    POST_TIMETABLE: '/timetable',
    PUT_TIMETABLE: (query) => `/timetable?${query}`,
    GET_TIMETABLE_COURSE: (query) => `/timetable/course/${query}`,
  },
  ENROLLMENT: {
    POST_EXIST_STUDENT_ENROLLMENT: `/student/enrollment`,
    POST_STUDENT_ENROLLMENT: (inquiryId) => `/student/enrollment/${inquiryId}`,
    PUT_STUDENT_ENROLLMENT: (studentenrollmentId) => `/student/enrollment/${studentenrollmentId}`,
    GET_STUDENT_FEE_STRUCTURE: (studentId) => `/student/payment-history/${studentId}`,
    GET_FEE_STRUCTURE: (courseId, batchId, branchId, studentId) => studentId ? `/course/branch/fees/${courseId}/${batchId}/${branchId}?studentId=${studentId}` : `/course/branch/fees/${courseId}/${batchId}/${branchId}`,
    GET_BRANCH_LIST : (courseId)=>`/branch/batch/${courseId}`,
    GET_COURSE_FEES : (courseId,batchId)=>`/branch/batch/${courseId}/${batchId}`
  },
  INQUIRY_SOURCE:{
    GET_INQUIRY_SOURCE:'/source',
    PUT_INQUIRY_SOURCE : (sourceId)=>`/source/${sourceId}`
  }
}
